// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import Vuex from "vuex";
import store from "@/store/store";
import "lib-flexible/flexible";
import "./assets/style/api.css";
import VueScroller from "vue-scroller";
import Calendar from "vue-mobile-calendar";
import "./assets/style/swiper.min.css";
import "./assets/js/swiper.min.js";
import "./styles/index.scss";

import './assets/style/public_color.css';
import './assets/style/public_style.css';
import './assets/style/public_icon.css';

Vue.use(Calendar);
Vue.config.productionTip = false;
Vue.use(VueScroller);
Vue.use(Vuex);

import VDistpicker from "v-distpicker";
Vue.component("v-distpicker", VDistpicker);

import { post, fetch, patch, put, posts } from "./utils/http";
//定义全局变量
Vue.prototype.$post = post;
Vue.prototype.$fetch = fetch;
Vue.prototype.$patch = patch;
Vue.prototype.$put = put;
Vue.prototype.$posts = posts;

import VueCookies from "vue-cookies";
Vue.use(VueCookies);



new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js